import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { TextField, InputAdornment, IconButton, Tooltip } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";

function ResultTextField(props: any) {
  const { id, label, getOutputText, style, tooltip, handleClick } = props;
  return (
    <TextField
      id={id}
      label={label}
      sx={{
        margin: 1,
        whiteSpace: "nowrap",
      }}
      value={getOutputText()}
      style={style}
      variant="standard"
      InputProps={{
        readOnly: true,
        endAdornment: (
          <Tooltip title={tooltip}>
            <InputAdornment position="end">
              <CopyToClipboard text={getOutputText()}>
                <IconButton
                  // label={"copy-"+label}
                  onClick={handleClick}
                  disabled={!getOutputText()}
                  size="large"
                >
                  <AssignmentIcon />
                </IconButton>
              </CopyToClipboard>
            </InputAdornment>
          </Tooltip>
        ),
      }}
    />
  );
}

export default ResultTextField;
